<template>
  <div class="g-container">
    <div class="m-slider-banner" id="lisss" style="z-index:1">
       <!--<swiper :options="swiperOption" ref="mySwipers" >
        <swiper-slide v-for="(item,index) in banner" :key="index">
          <a
            class="oper-pic"
            :style="{backgroundImage:'url(' + item.picPath + ')'}"
            :href="item.outLink"
          ></a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>-->
      <el-carousel :interval="5000" arrow="never"  ref="remarkCarusel" :offset="1">
        <el-carousel-item v-for="(item,index) in banner" :key="index" >
        <a :href="item.OutLink" target="_Blank"
            class="oper-pic"
            :style="{backgroundImage:'url(' + item.PicPath + ')'}"           
          ></a>
          
        </el-carousel-item>
      </el-carousel>
      <div class="baop">
        <div></div>
      </div>
    </div>

    <div class="m-title">
      <div class="ad-slogan-pic">
        <div class="liuC"><img src="../../html/pages/help/contactUs/images/liuC.png" alt="" class="liuCImg"> <b class="fontsize">服务流程</b> </div>
        <ul>
          <li >
            <img src="../../html/pages/help/contactUs/images/zu1.png" alt />
            <p>透明施工、社会监督、进度可视化</p>
          </li>
          <li class="zuImg">
            <img class="arrow" src="../../html/pages/help/contactUs/images/zu.png" alt="">
          </li>
          <li>
            <img src="../../html/pages/help/contactUs/images/zu2.png" alt />
            <p>权威的现场施工、解决方案</p>
          </li>
          <li class="zuImg">
            <img class="arrow" src="../../html/pages/help/contactUs/images/zu.png" alt="">
          </li>
          <li>
            <img src="../../html/pages/help/contactUs/images/zu3.png" alt />
            <p>绿建、教体同行的圈内互动</p>
          </li>
          <li class="zuImg">
            <img class="arrow" src="../../html/pages/help/contactUs/images/zu.png" alt="">
          </li>
          <li>
            <img src="../../html/pages/help/contactUs/images/zu4.png" alt />
            <p>第一时间的行业资讯及观点</p>
          </li>
          <li class="zuImg">
            <img class="arrow" src="../../html/pages/help/contactUs/images/zu.png" alt="">
          </li>
          <li>
            <img src="../../html/pages/help/contactUs/images/zu5.png" alt />
            <p>绿建防护与维修平台堆品质信用，绿安全环境</p>
            <p></p>
          </li>
        </ul>
      </div>
    </div>
    <div class="baf5f5f5">
      <div class="m-container m-width bafffs">
      <!--水性跑到 模板1-->
      <div class="mh-column-content" v-for="(txt,index) in pageInfos">
        <div class="mh-left-main">
          <div class="mt-main" >
            <div class="common-tit-h1">
              <img src="../../html/pages/help/contactUs/images/shuiP.png" alt="" class="log shuiP">
              <b  class="fontsize paoDao">{{txt.Title}}</b>
            </div>
            <div class="case-column">
              <div>
                <!--左侧导航-->
                <div class="paoD">
                  <i class="paoDImg" :style="{backgroundImage:'url(' + txt.PicPath + ')'}">
                    <div :style="{backgroundColor:'#'+txt.DescHex}" class="div_div">
                      
                    </div>
                    <div class="EAU">{{txt.Desc}}</div>

                    
                   </i> 
                  <div class="paoDbot" :style="{backgroundColor:'#'+txt.Hex}">
                    <div class="kefu">
                      <img src="../../html/pages/help/contactUs/images/kefu.png" alt="" class="kefuImg">
                      <b class="fontsize">咨询热线</b>
                    </div>
                    <div class="disnH fontsize"><b>{{txt.Phone}}</b></div>
                    <div class="contactBut">
                      <a href="tencent://message/?uin=849625904&amp;Site=&amp;Menu-=yes" class="contactBut_a">
                        <span class="qq">在线QQ</span>
                      </a>
                      <span class="inquiry" @click="outer(txt.Id)">咨询问价</span>
                    </div>
                  </div>
                </div>
                <!--中间商品-->
                <div>
                  <div class="imgtop" v-for="(tet,indexs) in txt.proInfos.pcInfo" :key="indexs">
                    <img :src="tet.PicPath" alt="" class="imgtop_img" @click="href_detail(tet.OutLink)" style="border-radius: 5px;">
                  </div>
                  <div class="maleft20">
                    <case-item :info="item" v-for="(item,index) in txt.cases" :key="index"></case-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mh-right-main">
          <div class="petite-box">
            <div class="petite-list">
              <petite-item v-for="(item,index) in txt.coursewares" :info="item" :key="index" :message="index"></petite-item>
            </div>
          </div>
        </div>
      </div>
      <!--找建材 模板2-->
      <div class="mh-column-content" v-if="pageSearchType !=''">
        <div class="mh-left-main-bafff">
          <div class="mt-main">
            <div class="common-tit-h1">
              <img src="../../html/pages/help/contactUs/images/jianZ.png" alt="" class="log shuiP">
              <b class="fontsize paoDao">找建材</b>
            </div>
           <div class="marTOP20">
              <div class="baF4F9FF">
                <b class="fontsize ell">{{pageSearchType[0].Title}}</b><br>
                <img :src="pageSearchType[0].PicPath" alt="" class="marTOP20 materialSize cupo" @click="sousuo(pageSearchType[0].Title)">
              </div>
              <div class="baF4F9FF">
                <b class="fontsize ell">{{pageSearchType[1].Title}}</b><br>
                <img :src="pageSearchType[1].PicPath" alt="" class="marTOP20 materialSize cupo" @click="sousuo(pageSearchType[1].Title)">
              </div>
              <div class="baF4F9FF padd10-25">
                  <b class="fontsize matop30 ell">{{pageSearchType[2].Title}}</b>
                  <img :src="pageSearchType[2].PicPath" alt="" class="paleft28 materialSize110 cupo" @click="sousuo(pageSearchType[2].Title)">
              </div>
              <div class="baF4F9FF padd10-25 marTOP20">
                  <b class="fontsize matop30 ell">{{pageSearchType[3].Title}}</b>
                  <img :src="pageSearchType[3].PicPath" alt="" class="paleft28 materialSize110 cupo" @click="sousuo(pageSearchType[3].Title)">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--匠心记 模板3-->
      <div class="mh-ingenuity-content">
        <div class="common-tit-h1">
          <img src="../../html/pages/help/contactUs/images/reJi.png" alt="" class="log shuiP">
          <b class="fontsize paoDao">匠心记</b>
          <span class="font15">现场经验分享，线下施工，线上体验</span>
        </div>
        <div class="ing-main">
          <router-link
            tag="a"
            target="_blank"
            :to="{name:'jxjPostDetail',params:{id:currentJxj.id}}"
            class="ing-information"
          >
            <div class="ing-hd">
              <div class="ing-face">
                <img :src="currentJxj.headImage" alt />
              </div>
              <div class="ing-info">
                <h2 class="ing-tit">{{currentJxj.projectName}}</h2>
                <div class="ing-status">
                  <span class="ing-sta-col">{{currentJxj.nickName}}</span>
                  <!-- <span class="ing-sta-col">12小时前</span> -->
                </div>
              </div>
            </div>
            <a class="ing-article"></a>
            <!--鼠标移上图片变大 + hover-scale -->
            <!--图片高度不固定 + h-auto-->
            <div class="cp-column" style='height: 320px;overflow: hidden;'>
              <a class="cp-item" v-for="(img,i) in currentJxj.images" :key="i" v-if="currentJxj.images.length >=4">
                <img :src="img" alt />
              </a>
              <img :src="currentJxj.images[0]" v-else alt  style='height: 100%;width: 97%;object-fit: cover;'/>
            </div>
          </router-link>
          <div class="ing-roll">
            <swiper :options="swiperOption3" ref="jxjSwpier">
              <swiper-slide v-for="(jxjItem,i) in jxj" :key="i"> 
                <router-link
                  tag="a"
                  target="_blank"
                  :to="{name:'jxjDetail',params:{id:jxjItem.forumId}}"
                >
                  <span class="roll-face">
                    <img :src="jxjItem.headImage" alt />
                  </span>
                  <span class="roll-name">{{jxjItem.nickName}}</span>
                  <b>{{jxjItem.projectName}}</b>
                  施工上传了 {{jxjItem.postName}}
                </router-link>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>

      <!--咨询-预约弹窗-->
      <el-dialog title="立即免费预约厂家" :visible.sync="outerVisible">

          <div class="open_input">
              <input v-model="phone" @change="tel" type="text" placeholder="请输入您的手机号，厂家会尽快联系到您" :id="oInputId ? 'redInput':'oInput'">
              <span v-if="oInputId" class="tishi">请输入正确的手机号</span>
          </div>
          <el-dialog width="30%" title="成功预约，等待联系" :visible.sync="innerVisible" append-to-body >
              <div class="cg_img">
                  <i class="cg"></i>
              </div>
              <div class="changjia">厂家已接收到您的预约信息，稍后就会拨打您电话，请保持电话畅通!</div>
          </el-dialog>
          <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="open">立即预约</el-button>
          </div>
      </el-dialog>
      <!--<div class="mh-column-content border-none">
        <div class="mh-left-main">
          <div class="common-tit-h1">
            <b>圈子</b>
            <span>现场经验分享，线下施工，线上体验</span>
          </div>
          <div class="u-group-list">
            <ul>
              <li v-for="(item,index) in qz" :key="index">
                <group-item :info="item"></group-item>
              </li>
            </ul>
          </div>
          
        </div>
        <div class="mh-right-main1">
          <div class="ad-list">
            <ad-item v-for="(item,index) in hzqy" :key="index" :info="item"></ad-item>
          </div>
        </div>
      </div>-->
      <div class="mh-column-content mabot80">
        <div class="mh-left-main-bafff">
          <div class="mt-main">
            <div class="common-tit-h1">
              <img src="../../html/pages/help/contactUs/images/anli.png" alt="" class="log shuiP">
              <b class="fontsize paoDao">案例鉴赏</b>
            </div>



            <div class="">
              <div class="fleft" v-for="item,index in rmal" :class="'load_'+(index%8)" :key="index">
                <img :src="item.bgImg" alt="" :class="'cases_'+(index%8)" @click="goDetail(item.id)">
                <div class="makc"></div>
                <span class="makc_font">{{item.title}}</span>
              </div>
            </div>
            <div class="text_center">
              <div v-if="pageSize<rmal.length" @click='loadMore' >
                <span class="init_tex">加载更多</span> <img src="../../html/pages/help/contactUs/images/GD.png" alt="" class="imgGD">
              </div>
              <div class="load-more mr-bottom" v-else >没有更多了</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import '../../html/pages/home/home.scss';
import '../../html/components/banner/banner.scss';
import '../../html/components/picture/picture.scss';
import '../../html/components/course/course.scss';

import { swiper, swiperSlide } from 'vue-awesome-swiper';

// import sloganItem from './components/slogan-item/slogan-item';
import caseItem from './components/case-item/case-item';
// import newsItem from './components/news-item/news-item';
import petiteItem from './components/petite-item/petite-item';
import courseItem from './components/course-item/course-item';
import groupItem from './components/group-item/group-item';
import adItem from './components/ad-item/ad-item';

import { home, domain,Index2,HotCaseMore,homeAdvisory } from '../../api/index';
import fetch from '../../pubilc/fetch/fetch';

import stars from '../../pubilc/util/stars';

import timeago from '../../pubilc/util/timeago';
export default {
  name: 'home',
  data() {
    return {
      hzqy: [],
      // bgImg: null,
      banner: [], //首页banner
      cyfa: [], //常用方案
      rmal: [], //热门案列
      pageInfos:[],
      pageSearchType:[],
      ljyw: [], //绿建要闻
      jxj: [], //匠心记
      currentJxj: {},
      banner666:[],
      qz: [], //圈子
      cpkc: [], //产品课程
      swiperOption: {
        // slidesPerView: 3,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          touchMoveStopPropagation :true,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        on:{
          slideChangeTransitionEnd: () => {
            var _this = this
            // setTimeout(function(){
              _this.inits()
            // },1000); 
          },
          init:() =>{
            var _this = this
            setTimeout(function(){
              _this.inits()
            },1000); 
          },
          
        }
      },
      swiperOption3: {
        // pagination: '.swiper-pagination',
        slidesPerView: 9,
        direction: 'vertical',
        autoplay: {
          delay: 5000
        },
        loop: true,
        on: {
          slideChangeTransitionEnd: () => {
            let ss = this.$refs.jxjSwpier.swiper;
            let i = ss.activeIndex;
            this.currentJxj = this.jxj[i];
            // alert(this.activeIndex);//切换结束时，告诉我现在是第几个slide
          }
        }
      },
      productLists:[{id:1},{id:2},{id:3},{id:4}],
      pageSize: 0,
      outerVisible: false,
      oInputId:false,
      phone:'',
      innerVisible: false,
      PopupId:''
    };
  },
  methods: {
    goDetail(id){
      let routeData = this.$router.resolve({ name: 'caseDetal', params: { id: id } });
      window.open(routeData.href, '_blank');
    },
    sousuo(tit){
      let routeData = this.$router.resolve({ name: 'searchIndex', query: { type:2,searchStr: tit}});
      window.open(routeData.href, '_blank');
    },
    href_detail(txt){
      window.open(txt, '_blank');
    },
    async  open() {
        if(this.phone  || this.phone !=''){
            this.innerVisible=true;
            this.outerVisible = false;
            this.oInputId = false;
            let res = await homeAdvisory({
                id: this.PopupId,
                phone:this.phone
            });
        }else{
            this.oInputId = true; 
        }
        
    },
    tel() {
        if (!/^1[345789]\d{9}$/.test(this.phone)) {
            // alert("请输入正确的手机号");
            this.oInputId = true;
            this.phone = "";
            return;
        }else{
            this.oInputId = false; 
        }
    },
    outer(id){
        this.outerVisible = true;
        this.oInputId = false;
        this.phone = '';
        this.PopupId=id
    },
    changeCampus(val){
      var _this = this
      var classname = document.getElementsByClassName('el-carousel__button')
      classname.forEach(function(item,i,arr2){
        _this.banner666.forEach(function(txt,index,arr){
          if(i == index){
            item.innerHTML = txt
          }
        })
      })
    },
    async loadMore(){
      let res = await HotCaseMore({
        index: this.pageSize+=1,
        size: 8
      });
      if (res.Type == 'Success') {
        this.rmal = this.rmal.concat(res.Data.rmal);
      }
        },
    inits(){
      var _this = this
      var classname = document.getElementsByClassName('swiper-pagination-bullet')
      classname.forEach(function(item,i,arr2){
        _this.banner666.forEach(function(txt,index,arr){
          if(i == index){
            item.innerHTML = txt
          }
        })
      })
    },
    async Index2(){
      var _this = this
      let res = await Index2();
      if (res.Type == 'Success') {
        this.banner = res.Data.banner;
        res.Data.banner.forEach(function(txt,index,arr){
          _this.banner666.push(txt.Title)
        })
        this.pageInfos = res.Data.pageInfos;
        
        this.pageSearchType = res.Data.pageSearchType
        this.jxj = res.Data.jxj;
        this.currentJxj = this.jxj[0];
        this.rmal = res.Data.rmal;
        this.pageInfos.forEach(function (item) {
          item.cases.forEach(function(txt){
            txt.stars = stars(txt.score);
          })
        });
        this.cyfa = res.Data.cyfa;
      }
      setTimeout(function(){
          _this.changeCampus()
        },1000);
    },
    async getHomeInfo() {
      var _this = this
      let res = await home();
      if (res.Type == 'Success') {
        document.title = res.Data.title;
        this.banner = res.Data.banner;
        
        // this.bgImg = res.Data.bgImg;
        this.cyfa = res.Data.cyfa;
        // this.rmal = res.Data.rmal;
        this.ljyw = res.Data.ljyw;
        this.jxj = res.Data.jxj;
        this.currentJxj = this.jxj[0];
        setTimeout(function(){
          _this.changeCampus()
        },1000); 
        this.qz = res.Data.qz;
        this.cpkc = res.Data.cpkc;
        this.hzqy = res.Data.hzqy;
        this.cpkc.forEach(function (item) {
          item.stars = stars(item.score);
        });
      }
    },
    changejxjItem(i) {
      this.currentJxj = this.jxj[i];
    }
  },
  created() {
    // this.getHomeInfo();
    this.Index2(); 
  },
  components: {
    swiper,
    swiperSlide,
    // sloganItem,
    caseItem,
    // newsItem,
    petiteItem,
    courseItem,
    groupItem,
    adItem
  }
};
</script>
<style>
.el-carousel .el-carousel__indicators--horizontal{z-index:8;pointer-events: none;}
.baop{width: 1197px;
    position: relative;
    margin: 0 auto;
    top: -607px;z-index: 6;
    left: 0;pointer-events: none;}
.baop div{background:red;min-height:300px;background: #fff;
    opacity: 0.9;
    width: 240px;
    position: relative;
    left: 957px;} 
.ell{width: 91px;}
.fleft{margin-right: 18px;}
.w280{width:280px;height:220px;top: 186px;}
.makc{height: 34px!important;}
.w560{width:560px;height:220px;top: 186px;}
.top192{top: 192px;}
.imgtop_img{width: 220px;height: 120px;}
.el-dialog__headerbtn:hover{background:#fff;}
.cg_img {margin: 0 auto;width: 65px;}
.el-dialog__title{font-size: 20px;font-weight: 600;color: #333;}
.el-dialog__header{margin: 0 auto;padding: 72px 20px 10px;width: 180px;}
.el-dialog{width: 460px;height: 380px;}
.el-button--primary{background: #FF5A00;color: #fff;font-size: 16px;border: none;width: 320px;}
.dialog-footer{margin: 0 auto;width: 320px;padding-top: 15px;}
.el-button--primary:focus, .el-button--primary:hover{background: #FF5A00;color: #fff;}
.tishi{position: absolute;left: 59px;top: 184px;font-size: 12px;color: red;}
input::-webkit-input-placeholder {font-size:12px;}
.open_input{width: 344px; margin: 0 auto;}
.el-dialog__headerbtn .el-dialog__close{color: #5f5f5f;font-size: 24px;}
.el-dialog__title{font-size: 20px;font-weight: 600;color: #333;}
.el-dialog__header{margin: 0 auto;padding: 72px 20px 10px;width: 180px;}
.open_input #oInput{width: 320px; padding: 10px;padding: 12px 10px;border: 1px solid #DEDEDE;}
.open_input #redInput{border: 1px solid red;width: 320px; padding: 10px;padding: 12px 10px;}
.contactBut span{color:#fff;cursor: pointer;}
.contactBut_a{cursor: inherit;}
.m-slider-banner .swiper-pagination-bullet.swiper-pagination-bullet-active{background:#00B86D!important;}
.paoD{float:left;}
.suX{display: inline-block;position: absolute;top: 272px;left: 70px;color: #Fff;font-size: 16px;}
.EAU{color: #Fff;font-size: 16px;word-wrap: break-word;z-index: 5;width: 158px;text-align: center;position: relative;top: 248px;left: 23px;}
.paoDImg .div_div{background: #00831C;opacity: 0.4;text-align: center;display: block;position: absolute;top: 240px;width: 160px;left: 20px;min-height: 64px;z-index: 1;}
.paoDImg{width:200px;display:block;height:520px;position: relative;}
.paoDbot{background:#30C056;width:200px;height:183px;color:#fff;}
.m-slider-banner .swiper-pagination-bullets{min-height: 300px;float: right;position: relative;top: -374px;background: #fff;width: 240px;left: -380px;box-shadow:0px 10px 13px 0px rgba(0, 0, 0, 0.2);background: rgba(255,255,255,0.8);}
.m-slider-banner .swiper-pagination-bullets .swiper-pagination-bullet{position: relative;display: list-item;}
.m-slider-banner .swiper-pagination-bullets .swiper-pagination-bullet{position: initial;padding: 20px 0;width: 240px;line-height: 9px;background: rgba(255,255,255,0.1);}
.m-slider-banner .swiper-pagination-bullet.swiper-pagination-bullet-active{background:#46da98;color:#fff;}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet{margin:0;}
.liuCImg{width:21px;height:21px;margin-right: 15px;}
.log{width:21px;height:21px;}
.fontsize{font-size:17px!important;}
.shuiP{margin-right:10px;}
.paoDao{margin-top:-2px;display:inline-block;}
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
.oper-pic{    width: 100%;
    height: 100%;
    display: block;
    text-align: center;
    margin: 0 auto;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: auto 100%;}
.el-carousel__container {
    height: 450px;
}
.m-slider-banner img{object-fit:cover;}
.el-carousel--horizontal {overflow: hidden;}
.el-carousel .el-carousel__indicators--horizontal{
    
    width: 1197px;
    position: relative;
    margin: 0 auto;
    top: -382px;left:0;webkit-transform: inherit;
    transform: inherit;}
.el-carousel__indicators--horizontal{left: 75%;}
.el-carousel__indicator--horizontal{display: -webkit-box;
    padding: 12px 4px;
    height: 18px;
    color: #595B5E;
    width: 280px;
    position: relative;
     width: 232px;
    left: 957px;pointer-events: auto;}
.el-carousel__indicator.is-active{background:rgba(0,184,109,1);color:#fff;}
.el-carousel__indicator.is-active button{color:#fff;}
.el-carousel__button{width: 198px;height: initial;opacity: initial;background: initial;margin: 0 auto;margin-left: 21px;overflow: hidden;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;text-align: left;}
button:hover{background:rgba(0,184,109,1);}
</style>